import axios from 'axios';
import { SnapshotValidation } from 'types';

export async function getSnapshotValidation(
  snapshotId: number
): Promise<SnapshotValidation> {
  const url = `/api/snapshot-validation/${snapshotId}`;

  try {
    const { data } = await axios.get(url);
    return data as SnapshotValidation;
  } catch (err) {
    throw err;
  }
}
